import { ReactNode } from 'react'
import SplitControl from '@/components/business/SplitControl'
import NotFound from '@/pages/NotFound'
import Loading from '@/components/generics/Loading'

type Props = {
  children: NonNullable<ReactNode>
}

const SplitHandler = ({ children }: Props) => {
  return (
    <SplitControl
      splitName="enable_on_sales_page"
      treatmentOff={<NotFound />}
      loading={<Loading />}
    >
      {children}
    </SplitControl>
  )
}

export default SplitHandler
